export default __webpack_public_path__ + "static/media/slice-annotation.1bc3729c.png";